import React, { useRef } from 'react'

import { Button, Col, Picker, Row } from 'components'
import {
  DraggableDialog,
  resetModalState
} from 'components/DraggableDialog/DraggableDialog'
import { DeleteIcon } from 'components/Icons'
import moment from 'moment'
import Draggable from 'react-draggable'
import { SPACING } from 'utils'

import {
  DialogActionsStyled,
  DialogContentStyled,
  DialogTitleStyled
} from '../../../../../../ModalNovJobs.styles'
interface IModalDatas {
  isOpen?: boolean
  toggleModal?: () => void
  listDatas?: any[]
  onSubmitModal?: () => void
  handleDatePicker?: (data, index) => void
  handleNewItem?: () => void
  handleDelete?: (id) => void
}

const ModalDatas: React.FC<IModalDatas> = ({
  isOpen,
  toggleModal,
  onSubmitModal,
  listDatas,
  handleDelete,
  handleNewItem,
  handleDatePicker
}) => {
  const draggableReference = useRef<Draggable>(null)

  return (
    <DraggableDialog
      reference={draggableReference}
      showModal={isOpen}
      width={'sm'}
    >
      <DialogTitleStyled>Datas</DialogTitleStyled>
      <DialogContentStyled>
        {listDatas.map((data, index) => (
          <Col key={index} marginBottom={SPACING.spacing10}>
            <Row alignItems="center" justifyContent="start">
              <Picker
                marginRight={SPACING.spacing15}
                label="Data"
                value={moment(data.data).format()}
                onChange={(data) => handleDatePicker(data, index)}
              />

              {listDatas.length - 1 === index ? (
                <Button text="+" onClick={handleNewItem} />
              ) : (
                <DeleteIcon onClick={() => handleDelete(data.id)} />
              )}
            </Row>
          </Col>
        ))}
      </DialogContentStyled>
      <DialogActionsStyled>
        <Button
          text="Voltar"
          onClick={() => {
            toggleModal()
            resetModalState(draggableReference)
          }}
          variantButton="text"
        />
        <Button
          text="Salvar"
          onClick={() => {
            onSubmitModal()
            resetModalState(draggableReference)
          }}
        />
      </DialogActionsStyled>
    </DraggableDialog>
  )
}

export default ModalDatas
